import {createRouter, createWebHistory} from 'vue-router';
import {deleteIndexedDB} from "@/plugins/IndexedDB";
import {useMemberStore} from "@/services/store/memberStore";
import _ from "lodash"
import {useClaimStore} from "@/services/store/claimStore";
import claimApi from "@/services/api/claimApi";
import commonJs from "@/plugins/commonJs";
import Device from "@/utils/Device"
import {togglePop} from "@/utils/commonUi";
import myPageApi from "@/services/api/myPageApi";
import {useComponent} from "@/utils/compossable/$component";
import reflashAndBackControl from "@/utils/reflashAndBackControl";

const mainLayout = '/ui/layout/MainLayout';
const claimLayout = '/ui/layout/ClaimLayout';
const defaultLayout = '/ui/layout/DefaultLayout';
const subHomeLayout = '/ui/layout/SubHomeLayout';
const noGnbLayout = '/ui/layout/NoGnbLayout';

class GenericRouter {
    constructor() {
        const baseContext = '/claim/web';

        const routes = [
            {
                path: `${baseContext}/Main`,
                component: () => import('./ui/Main.vue')
            },
        ];

        this.instance = createRouter({
            history: createWebHistory(),
            routes: routes,
            scrollBehavior(to, from, savedPosition) {
                if (savedPosition) {
                    return savedPosition;
                } else {
                    return {x: 0, y: 0};
                }
            }
        });

        Object.getOwnPropertyNames(this.__proto__).forEach(prop => {
            if (prop != 'constructor' && typeof this.instance[prop] == 'undefined') {
                this.instance[prop] = this.__proto__[prop];
            }
        })

        this.baseContext = baseContext;
    }

    async dynamic() {
        let routes = await apiCall.call(this);

        // navigation guard
        this.instance.beforeEach(async function (to, from, next) {
            if (Device.isMobile()) {
                if (to.matched.some(function (routeInfo) {
                    return commonJs.isEmpty(routeInfo.meta.isMobilePage);
                })) {
                    next('/claim/web/mobileNoticePop');
                } else {
                    document.title = to.name === 'Main' ? '실손24' : to.meta.title + ' - 실손24' || '실손24'
                    next();
                }
            } else {
                const memeberStore = useMemberStore();
                if (memeberStore.member.openPopupId !== '') {
                    memeberStore.member.openPopupId = '';
                }
                const component = useComponent();
                const routerFromPath = _.compact(from.path.split("/"));
                const routerToPath = _.compact(to.path.split("/"));
                if (routerToPath[2] !== 'login' && routerFromPath.length) {
                    component.pageLoading.enable = true;
                }
                // to : 이동할 url
                if (to.matched.some(function (routeInfo) {
                    const store = useMemberStore();
                    const loggedIn = store.member.status.isLogin;
                    //대리청구 알리미 페이지 미로그인 시 접근 허용
                    const isLoginAllowed = commonJs.isEmpty(to.meta.isLoginAllowed) ? true : to.meta.isLoginAllowed;
                    return routeInfo.meta.authRequired && !loggedIn && isLoginAllowed;
                })) {
                    //로그인 하지않고 청구화면 진입 시
                    if (to.matched[0].meta.isAccessPath && to.matched[0].name !== 'custSupp') {

                        const claimStore = useClaimStore();
                        claimStore.init();

                        //myPage 하위메뉴 진입허용
                        if (routerToPath[2] === 'myPage') {
                            sessionStorage.setItem('accessPath', to.matched[1].path);
                        } else {
                            sessionStorage.setItem('accessPath', to.matched[0].path);
                        }
                        //로그인 하지않고 문의하기 진입 시
                    } else if (to.matched[0].name === 'custSupp') {
                        sessionStorage.setItem('accessPath', to.matched[1].path);
                    }

                    next('/claim/web/login/loginCertificate/3');
                } else {
                    document.body.classList.remove('lock');
                    const storageToken = JSON.parse(sessionStorage.getItem("token"));
                    // next : to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
                    //로그인 후 로그인 페이지 진입 시 메인으로 이동
                    if (routerToPath[2] === 'login' && !commonJs.isEmpty(storageToken)) {
                        next({name: 'Main'});
                    } else {
                        next();
                    }

                    document.title = to.name === 'Main' ? '실손24' : to.meta.title + ' - 실손24' || '실손24'
                    window.touchennxwebparams[3] = top.document.title;
                    TouchEnNx.success({success: "true"});

                    //청구 -> 청구외 다른메뉴 진입 시(메인화면 포함) 새로고침,뒤로가기 해제
                    if (!commonJs.isEmpty(routerFromPath[2]) && routerFromPath[2].includes('Claim')) {
                        if ((!commonJs.isEmpty(routerToPath[2]) && !routerToPath[2].includes('Claim')) || routerToPath.length < 3) {
                            reflashAndBackControl.handlerDelReflashAndBack();
                        }
                    }
                }
            }

        });

        /*마이페이지 메뉴에서 첨부파일을 등록 후 마이페이지 안에 다른 메뉴로 이동 시 첨부파일을 초기화 하기위해서 설정*/
        this.instance.beforeEach((to, from, next) => {
            if (to.path.startsWith('/claim/web/myPage')) {
                try {
                    deleteIndexedDB();
                    next();
                } catch (err) {
                    next(err);
                }
            } else {
                next();
            }
        });

        this.instance.beforeEach((to, from, next) => {
            document.body.classList.remove('lock')
            next()
        })

        this.instance.afterEach(() => {
            const focusSequence = () => {
                // 1. 먼저 body로 포커스 초기화
                document.body.setAttribute('tabindex', '-1')
                document.body.focus()

                // 2. 잠시 후 첫 번째 헤딩으로 포커스
                setTimeout(() => {
                    const firstHeading = document.querySelector('h1')
                    if (firstHeading) {
                        firstHeading.setAttribute('tabindex', '-1')
                        firstHeading.focus()
                    }

                    // 3. 마지막으로 skip-nav로 포커스
                    setTimeout(() => {
                        const skipNav = document.querySelectorAll('#header')
                        if (skipNav && skipNav.length > 0) {
                            const firstSkipNav = skipNav[0]
                            firstSkipNav.setAttribute('tabindex', '-1')
                            firstSkipNav.focus()
                        }
                        // body의 tabindex 제거
                        document.body.removeAttribute('tabindex')
                    }, 10)
                }, 10)
            }
            const component = useComponent();
            setTimeout(() => {
                component.pageLoading.enable = false;
                if (Device.isMobile()) {
                    focusSequence();
                }
            }, 500);
        })

        routes.forEach(route => {
            this.instance.addRoute(route);
        });

        this.instance.onError((error) => {
            if (error.message.includes('chunk')) {
                window.location.reload();
            }
        })

        function beforeEnterClaimUnValidAccessCheck(to, from, next) {
            const routerToPath = _.compact(to.path.split("/"));
            const isLoginAllowed = commonJs.isEmpty(to.meta.isLoginAllowed) ? true : to.meta.isLoginAllowed;

            //대리청구 알리미 페이지 를 제외한 url 접근 시 청구 내 페이지 진입불가
            if (from.path === '/' && routerToPath[2].toLowerCase().includes('claim') && isLoginAllowed) {
                next({name: 'claimNotFound'})
            } else {
                next();
            }
            next();
        }

        function beforeClaimRouterEnter(to, from, next) {
            const $component = useComponent();
            const routerToPath = _.compact(to.path.split("/"));

            //대리청구 알리미 페이지 미로그인 시 접근 허용
            const isLoginAllowed = commonJs.isEmpty(to.meta.isLoginAllowed) ? true : to.meta.isLoginAllowed;

            //main진입
            if (routerToPath.length === 2) {
                const claimStore = useClaimStore();
                claimStore.init();
                next();

            } else if (routerToPath.length > 3 && ['insuClaim', 'childClaim', 'deputyClaim'].includes(routerToPath[2])) {

                //알리미 페이지 제외 19세미만 나이 검증 후 청구 페이지 진입
                if (isLoginAllowed) {
                    myPageApi.getMyInformation().then((data) => {
                        //생년월일 및 성별이 있는 경우 19세 미만 체크
                        if (!commonJs.isEmpty(data.birthday) && !commonJs.isEmpty(data.sex)) {
                            const userBirthday = data.birthday
                            const userSex = data.sex
                            if (calculateAge(userBirthday, userSex)) {
                                $component.simpleAlert('만 19세 미만의 미성년자는 직접 나의 실손청구 신청을 할 수 없어요.\n친권자가 나의 자녀청구를 통해 청구가능해요.');
                                $component.alert.fn.fnSelect = function () {
                                    next({name: 'Main'})
                                }
                                return;
                            }
                        }
                        //청구 초기 세팅 및 청구 페이지 이동
                        beforeClaimSet(to, from, next)
                    });
                } else {
                    //청구 초기 세팅 및 청구 페이지 이동
                    beforeClaimSet(to, from, next)
                }
            }
        }

        //나의 청구이력 들어갈 때 본인인증 팝업 호출
        function beforeMyClaim(to, from, next) {
            const memberStore = useMemberStore();
            if (memberStore.member.loginMethodType === 'pwd' || memberStore.member.loginMethodType === 'sns') {
                memberStore.member.noticeTo = to.name;
                if (from.path === '/') {
                    memberStore.member.noticeForm = 'myPageHome'
                    next({name: 'claimNotFound'})
                } else {
                    if (!memberStore.member.certCheck) {
                        next(false);
                        togglePop('certificatePop2', true);
                    } else {
                        next();
                    }
                }
            } else {
                next();
            }
        }

        function beforeClaimSet(to, from, next) {
            const claimStore = useClaimStore();
            const memberStore = useMemberStore();
            const routerToPath = _.compact(to.path.split("/"));
            const cookieYN = memberStore.isExistsNoticeCookie();
            //로그인 수단
            const loginMethod = memberStore.member.loginMethodType;
            //대리청구 알리미 페이지 미로그인 시 접근 허용
            const isLoginAllowed = commonJs.isEmpty(to.meta.isLoginAllowed) ? true : to.meta.isLoginAllowed;

            //로그인 허용 url인경우 청구노티스 및 인증 체크
            if (isLoginAllowed) {
                memberStore.member.noticeTo = to.name;
                if (cookieYN) {
                    // if (!memberStore.member.certCheck) {
                    //     if (loginMethod === 'pwd' || loginMethod === 'sns') {
                    //         next(false);
                    //         memberStore.member.noticeTo = to.name;
                    //         togglePop('certificatePop2', true);
                    //     } else {
                    //
                    //         memberStore.member.certCheck = true;
                    //     }
                    // }
                    if (loginMethod === 'pwd' || loginMethod === 'sns') {
                        if (!memberStore.member.certCheck) {
                            next(false);
                            // memberStore.member.noticeTo = to.name;
                            togglePop('certificatePop2', true);
                        }
                    } else {
                        if (!memberStore.member.certCheck) {
                            next(false);
                            // memberStore.member.noticeTo = to.name;
                            togglePop('certificatePop2', true);
                        } else {
                            // if (!memberStore.member.certCheck2) {
                            //     next(false);
                            //     memberStore.member.noticeTo = to.name;
                            //     togglePop('certificatePop2', true);
                            // }
                        }
                    }
                } else {
                    if (!memberStore.member.noticeCheck) {
                        next(false);
                        //노티스 후 router처리할 path name
                        // memberStore.member.noticeTo = to.name;
                        togglePop('guideModal', true);
                    }
                    // if (loginMethod === 'pwd' || loginMethod === 'sns') {
                    //     next(false);
                    //     memberStore.member.noticeTo = to.name;
                    //     togglePop('certificatePop2', true);
                    // } else {
                    //     if (!memberStore.member.certCheck) {
                    //         next(false);
                    //         memberStore.member.noticeTo = to.name;
                    //         togglePop('certificatePop2', true);
                    //     } else {
                    //         // if (!memberStore.member.certCheck2) {
                    //         //     next(false);
                    //         //     memberStore.member.noticeTo = to.name;
                    //         //     togglePop('certificatePop2', true);
                    //         // }
                    //     }
                    // }
                }
            }

            if (memberStore.member.certCheck && commonJs.isEmpty(claimStore.claim.claimType)) {
                claimStore.init();

                if (routerToPath[2] === 'insuClaim') {
                    claimStore.setItem({claimType: "1"});
                    next();
                } else if (routerToPath[2] === 'childClaim') {
                    claimStore.setItem({claimType: "2"});
                    next();
                } else if (routerToPath[2] === 'deputyClaim') {
                    claimStore.setItem({claimType: "3"});
                    claimApi.getDeputyClaimStatus({}).then((data) => {
                        if (commonJs.isEmpty(data.value)) {
                            next({name: 'Main'});
                        } else {
                            let resultData = data.value.result

                            if (resultData.deputyClaimStcd === '01') {
                                next({name: 'deputyClaimInfo'});
                            } else if (resultData.deputyClaimStcd === '02') {
                                memberStore.member.noticeTo = 'delegateApproval';
                                next({name: 'delegateApproval'});
                            } else if (resultData.deputyClaimStcd === '03') {
                                memberStore.member.noticeTo = 'delegateApproval';
                                next({name: 'delegateApproval'});
                            }
                        }
                    })
                }

                //새로고침,뒤로가기 제어
                if (commonJs.isEmpty(touchennxwebpolicyinfo.ReflashNBack)) {
                    if (memberStore.member.noticeCheck) {
                        reflashAndBackControl.handlerSetReflashAndBack()
                    }
                }

            } else if (memberStore.member.certCheck || !isLoginAllowed) {
                if (routerToPath[2] === 'insuClaim') {
                    next();
                } else if (routerToPath[2] === 'childClaim') {
                    next();
                } else if (routerToPath[2] === 'deputyClaim') {
                    next();
                }

                //새로고침,뒤로가기 제어
                if (commonJs.isEmpty(touchennxwebpolicyinfo.ReflashNBack)) {
                    if (memberStore.member.noticeCheck) {
                        reflashAndBackControl.handlerSetReflashAndBack()
                    }
                }
            } else {
                next();
            }
        }

        //만나이 계산
        function calculateAge(userBirthday, userSex) {
            let fullBirtYear = null;
            let age = null;
            let sex = userSex;
            let birthday = userBirthday;

            //현재일자
            let today = new Date;
            let currentYear = today.getFullYear();
            let currentMonth = today.getMonth() + 1;
            let currentDay = today.getDate();

            //생년월일
            let year = parseInt(birthday.slice(0, 2), 10);
            let month = parseInt(birthday.slice(2, 4), 10);
            let day = parseInt(birthday.slice(4, 6), 10);

            if (['1', '2', '5', '6'].includes(sex)) {
                fullBirtYear = 1900 + year;
            } else {
                fullBirtYear = 2000 + year
            }
            // fullBirtYear = (sex === '1' || sex === '2') ? 1900 + year : 2000 + year;
            age = currentYear - fullBirtYear;

            //만나이시 한살 차감
            if (currentMonth < month || (currentMonth === month && currentDay < day)) {
                age--;
            }
            return age < 19
        }

        //모바일 앱 다운로드 팝업 호출 시 pc는 메인으로 강제 이동 모바일은 팝업 노출
        function mobileNoticeEnter(to, from, next) {
            if (!Device.isMobile()) {
                next({name: 'Main'});
            }else{
                next();
            }
        }

        function apiCall() {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve(
                        [
                            {
                                path: `${this.baseContext}/`,
                                name: 'Main',
                                component: () => import('./ui/Main.vue'),
                                meta: {
                                    title: '메인페이지',
                                    pageTitle: '메인페이지',
                                    layout: mainLayout,
                                    menuCate: '메인',
                                    isMobilePage: true
                                },
                                beforeEnter: [beforeClaimRouterEnter],
                            },
                            {
                                path: `${this.baseContext}/mobileNoticePop`,
                                name: 'mobileNoticePop',
                                component: () => import('@/components/atoms/MobileNoticePop.vue'),
                                meta: {
                                    title: '실손24',
                                    pageTitle: '실손24',
                                    layout: defaultLayout,
                                    menuCate: '실손24',
                                    isMobilePage: true
                                },
                                beforeEnter: [mobileNoticeEnter],
                            },
                            {
                                path: `${this.baseContext}/claimNotFound`,
                                name: 'claimNotFound',
                                component: () => import('@/ui/ClaimNotFound.vue'),
                                meta: {
                                    title: '오류페이지',
                                    pageTitle: '오류페이지',
                                    menuCate: '오류페이지',
                                    layout: noGnbLayout,
                                    isMobilePage: true
                                }
                            },
                            {
                                path: `${this.baseContext}/insuClaim`,
                                name: 'insuClaim',
                                redirect: `${this.baseContext}/insuClaim/selectClaim`,
                                meta: {authRequired: true, isAccessPath: true},
                                beforeEnter: [beforeEnterClaimUnValidAccessCheck, beforeClaimRouterEnter],
                                children: [
                                    {
                                        path: 'information',
                                        name: 'information',
                                        component: () => import('@/ui/menu/claim/insuClaim/information/InformationClaimVIew.vue'),
                                        beforeEnter: [beforeClaimRouterEnter],
                                        meta: {
                                            title: '보험계약 조회 조건 입력',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },

                                    {
                                        path: `insurance`,
                                        name: 'insurance',
                                        component: () => import('@/ui/menu/claim/insuClaim/insurance/InsuranceList.vue'),
                                        meta: {
                                            title: '보험계약 조회 및 선택',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        },
                                    },

                                    {
                                        path: `hospital`,
                                        name: 'hospital',
                                        component: () => import('@/ui/menu/claim/insuClaim/hospital/HospitalMainView.vue'),
                                        meta: {
                                            title: '병원 선택',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    // {
                                    //     path: `pharmacy`,
                                    //     name: 'pharmacy',
                                    //     component: () => import('@/ui/menu/claim/insuClaim/pharmacy/PharmacyListView.vue'),
                                    //     meta: {
                                    //         title: '약국 선택',
                                    //         menuCate: '나의 실손청구',
                                    //         pageTitle: '나의 실손청구',
                                    //         layout: claimLayout
                                    //     }
                                    // },

                                    {
                                        path: `treatMent`,
                                        name: 'treatMent',
                                        component: () => import('@/ui/menu/claim/insuClaim/treatMent/TreatMentView.vue'),
                                        meta: {
                                            title: '진료내역 선택',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        },
                                    },
                                    {
                                        path: `basicInfoClaim`,
                                        name: 'basicInfoClaim',
                                        component: () => import('@/ui/menu/claim/insuClaim/claimInfo/BasicInfoClaimView.vue'),
                                        meta: {
                                            title: '기본정보입력',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `detailInfoClaim`,
                                        name: 'detailInfoClaim',
                                        component: () => import('@/ui/menu/claim/insuClaim/claimInfo/DetailInfoClaimView.vue'),
                                        meta: {
                                            title: '나의 실손청구 정보 입력',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `bankList`,
                                        name: 'bankList',
                                        component: () => import('@/ui/menu/claim/insuClaim/claimInfo/BankListView.vue'),
                                        meta: {
                                            title: '지급계좌 선택',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `bankCreate`,
                                        name: 'bankCreate',
                                        component: () => import('@/ui/menu/claim/insuClaim/claimInfo/BankCreateView.vue'),
                                        meta: {
                                            title: '지급계좌 입력',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `attachFile`,
                                        name: 'attachFile',
                                        component: () => import('@/ui/menu/claim/insuClaim/claimInfo/AttachFileView.vue'),
                                        meta: {
                                            title: '보험사별 추가제출 필요한 파일 추가',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `detailClaim`,
                                        name: 'detailClaim',
                                        component: () => import('@/ui/menu/claim/insuClaim/resultClaim/DetailClaimView.vue'),
                                        meta: {
                                            title: '청구내용 확인',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: `resultClaim`,
                                        name: 'resultClaim',
                                        component: () => import('@/ui/menu/claim/insuClaim/resultClaim/ResultClaimView.vue'),
                                        meta: {
                                            title: '청구완료 안내',
                                            pageTitle: '나의 실손청구',
                                            menuCate: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: 'selectClaimNumber',
                                        name: 'selectClaimNumber',
                                        component: () => import('@/ui/menu/claim/insuClaim/selectClaim/ClaimNumberListView.vue'),
                                        meta: {
                                            title: '원청구 선택',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: 'selectClaim',
                                        name: 'selectClaim',
                                        component: () => import('@/ui/menu/claim/insuClaim/selectClaim/selectClaim.vue'),
                                        beforeEnter: [beforeClaimRouterEnter],
                                        meta: {
                                            title: '나의 실손청구 방식 선택',
                                            menuCate: '나의 실손청구',
                                            pageTitle: '나의 실손청구',
                                            layout: claimLayout
                                        }
                                    },
                                ]
                            },

                            {
                                path: `${this.baseContext}/childClaim`,
                                name: 'childClaim',
                                redirect: `${this.baseContext}/childClaim/myDataFindChild`,
                                meta: {authRequired: true, isAccessPath: true},
                                beforeEnter: [beforeEnterClaimUnValidAccessCheck, beforeClaimRouterEnter],
                                children: [
                                    {
                                        path: 'myDataFindChild',
                                        name: 'myDataFindChild',
                                        component: () => import('@/ui/menu/claim/childClaim/MyDataFindChildView.vue'),
                                        beforeEnter: [beforeClaimRouterEnter],
                                        meta: {
                                            title: '공공 마이테이터 조회',
                                            menuCate: '나의 자녀청구',
                                            pageTitle: '나의 자녀청구',
                                            layout: claimLayout
                                        }
                                    },
                                    {
                                        path: 'childSelect',
                                        name: 'childSelect',
                                        component: () => import('@/ui/menu/claim/childClaim/ChildSelectView.vue'),
                                        beforeEnter: [beforeClaimRouterEnter],
                                        meta: {
                                            title: '자녀선택',
                                            menuCate: '나의 자녀청구',
                                            pageTitle: '나의 자녀청구',
                                            layout: claimLayout
                                        }
                                    },

                                ]
                            },

                            {
                                path: `${this.baseContext}/deputyClaim`,
                                name: 'deputyClaim',
                                redirect: `${this.baseContext}/deputyClaim/deputyClaimInfo`,
                                meta: {authRequired: true, isAccessPath: true},
                                beforeEnter: [beforeEnterClaimUnValidAccessCheck, beforeClaimRouterEnter],
                                children: [
                                    {
                                        path: 'deputyClaimInfo',
                                        name: 'deputyClaimInfo',
                                        component: () => import('@/ui/menu/claim/deputyClaim/DeputyClaimInfoView.vue'),
                                        beforeEnter: [beforeClaimRouterEnter],
                                        meta: {
                                            title: '나의부모/제3자 청구 대상 정보입력',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            layout: claimLayout
                                        }
                                    },

                                    {
                                        path: `delegateApproval`,
                                        name: 'delegateApproval',
                                        component: () => import('@/ui/menu/claim/deputyClaim/DelegateApprovalView.vue'),
                                        meta: {
                                            title: '위임동의 요청',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            layout: claimLayout
                                        },
                                    },

                                    {
                                        path: `delegateApprovalFali`,
                                        name: 'delegateApprovalFali',
                                        component: () => import('@/ui/menu/claim/deputyClaim/DelegateApprovalFaliView.vue'),
                                        meta: {
                                            title: '나의부모/제3자 청구 위임동의 결과',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            layout: claimLayout
                                        },
                                    },

                                    {
                                        path: `deputyClaimResult`,
                                        name: 'deputyClaimResult',
                                        component: () => import('@/ui/menu/claim/deputyClaim/DeputyClaimResultView.vue'),
                                        meta: {
                                            title: '청구서 작성완료',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            layout: claimLayout
                                        },
                                    },
                                    //대리청구 알리미
                                    {
                                        path: `delegateApprovalReg`,
                                        name: 'delegateApprovalReg',
                                        component: () => import('@/ui/menu/claim/deputyClaimAlarm/DelegateApprovalRegView.vue'),
                                        meta: {
                                            title: '위임자 주민번호 입력',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            isLoginAllowed: false,
                                            layout: claimLayout
                                        },
                                    },
                                    {
                                        path: `agreeDelegateResult`,
                                        name: 'agreeDelegateResult',
                                        component: () => import('@/ui/menu/claim/deputyClaimAlarm/AgreeDelegateResultView.vue'),
                                        meta: {
                                            title: '위임자동의 완료',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            isLoginAllowed: false,
                                            layout: claimLayout
                                        },
                                    },
                                    {
                                        path: `deputyClaimDetail`,
                                        name: 'deputyClaimDetail',
                                        component: () => import('@/ui/menu/claim/deputyClaimAlarm/DeputyClaimDetailView.vue'),
                                        meta: {
                                            title: '청구내용확인',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            isLoginAllowed: false,
                                            layout: claimLayout
                                        },
                                    },
                                    {
                                        path: `resultDeputyClaim`,
                                        name: 'resultDeputyClaim',
                                        component: () => import('@/ui/menu/claim/deputyClaimAlarm/ResultDeputyClaimView.vue'),
                                        meta: {
                                            title: '청구서 작성완료(알리미)',
                                            menuCate: '나의부모/제3자 청구',
                                            pageTitle: '나의부모/제3자 청구',
                                            isLoginAllowed: false,
                                            layout: claimLayout
                                        },
                                    }
                                ]
                            },

                            {
                                path: `${this.baseContext}/myPage`,
                                name: 'myPage',
                                redirect: `${this.baseContext}/myPage/myPageHome`,
                                meta: {authRequired: true, isAccessPath: true},
                                children: [
                                    {
                                        path: "myPageHome",
                                        name: "myPageHome",
                                        component: () => import('@/ui/menu/myPage/MyPageHome.vue'),
                                        meta: {
                                            title: '마이페이지',
                                            pageTitle: '마이페이지',
                                            menuCate: '마이페이지',
                                            layout: subHomeLayout
                                        }
                                    },
                                    {
                                        path: "myInformation",
                                        name: "myInformation",
                                        component: () => import('@/ui/menu/myPage/myInformation/MyInformationView.vue'),
                                        meta: {
                                            title: '마이페이지 내정보',
                                            pageTitle: '내 정보관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "updateMyInfo",
                                        name: "updateMyInfo",
                                        component: () => import('@/ui/menu/myPage/myInformation/MyInfoUpdateView.vue'),
                                        meta: {
                                            title: '내 정보 수정',
                                            pageTitle: '내 정보관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "myClaim",
                                        name: "myClaim",
                                        component: () => import('@/ui/menu/myPage/myClaim/MyClaimListView.vue'),
                                        meta: {
                                            title: '마이페이지 청구이력',
                                            pageTitle: '청구이력',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        },
                                        beforeEnter: [beforeMyClaim],
                                    },
                                    {
                                        path: "myClaimDetail",
                                        name: "myClaimDetail",
                                        component: () => import('@/ui/menu/myPage/myClaim/MyClaimDetailView.vue'),
                                        meta: {
                                            title: '보험금청구내역상세',
                                            pageTitle: '보험금청구내역상세',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "myInsurance",
                                        name: "myInsurance",
                                        component: () => import('@/ui/menu/myPage/myInsurance/MyInsuranceListView.vue'),
                                        meta: {
                                            title: '나의보험관리 목록',
                                            pageTitle: '나의 보험관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "registMyInsurance",
                                        name: "registMyInsurance",
                                        component: () => import('@/ui/menu/myPage/myInsurance/RegistMyInsuranceView.vue'),
                                        meta: {
                                            title: '나의보험관리 안내',
                                            pageTitle: '나의 보험관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "attachInsurFile",
                                        name: "attachInsurFile",
                                        component: () => import('@/ui/menu/myPage/myInsurance/AttachInsurFileView.vue'),
                                        meta: {
                                            title: '보험증명서 제출',
                                            pageTitle: '나의 보험관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "resultAttachInsurFile",
                                        name: "resultAttachInsurFile",
                                        component: () => import('@/ui/menu/myPage/myInsurance/ResultAttachInsurFileView.vue'),
                                        meta: {
                                            title: '보험증명서 제출완료',
                                            pageTitle: '나의 보험관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "myHospital",
                                        name: "myHospital",
                                        component: () => import('@/ui/menu/myPage/myHospital/MyHospitalView.vue'),
                                        meta: {
                                            title: '나의 병원 목록',
                                            pageTitle: '나의 병원관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "myChildren",
                                        name: "myChildren",
                                        component: () => import('@/ui/menu/myPage/myChildren/MyChildListView.vue'),
                                        meta: {
                                            title: '자녀관리 목록',
                                            pageTitle: '나의 자녀관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }

                                    },
                                    {
                                        path: "registChild",
                                        name: "registChild",
                                        component: () => import('@/ui/menu/myPage/myChildren/RegistChildView.vue'),
                                        meta: {
                                            title: '자녀등록',
                                            pageTitle: '나의 자녀관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "resultRegistChild",
                                        name: "resultRegistChild",
                                        component: () => import('@/ui/menu/myPage/myChildren/ResultRegistChildView.vue'),
                                        meta: {
                                            title: '자녀등록신청완료',
                                            pageTitle: '나의 자녀관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: 'myDelegate',
                                        name: 'myDelegate',
                                        component: () => import('@/ui/menu/myPage/myDelegate/MyDelegateListView.vue'),
                                        meta: {
                                            title: '위임관리 목록',
                                            pageTitle: '나의 위임관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: 'detailMyDelegate',
                                        name: 'detailMyDelegate',
                                        component: () => import('@/ui/menu/myPage/myDelegate/MyDelegateDetailView.vue'),
                                        meta: {
                                            title: '위임관리 상세',
                                            pageTitle: '나의 위임관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: 'registMyDelegate',
                                        name: 'registMyDelegate',
                                        component: () => import('@/ui/menu/myPage/myDelegate/MyDelegateRegistView.vue'),
                                        meta: {
                                            title: '위임관리 입력',
                                            pageTitle: '나의 위임관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: 'updateMyDelegate',
                                        name: 'updateMyDelegate',
                                        component: () => import('@/ui/menu/myPage/myDelegate/MyDelegateRegistView.vue'),
                                        meta: {
                                            title: '위임관리 수정',
                                            pageTitle: '나의 위임관리',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        },
                                    },
                                    {
                                        path: "agreePolicy",
                                        name: "agreePolicy",
                                        component: () => import('@/ui/menu/myPage/myAgreePolicy/MyAgreePolicyList.vue'),
                                        meta: {
                                            title: '마이페이지 약관동의관리',
                                            pageTitle: '약관동의',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "mySetting",
                                        name: "mySetting",
                                        component: () => import('@/ui/menu/myPage/mySetting/MySettingView.vue'),
                                        meta: {
                                            title: '설정',
                                            pageTitle: '환경설정',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: "mySecurity",
                                        name: "mySecurity",
                                        component: () => import('@/ui/menu/myPage/mySetting/MySecurityView.vue'),
                                        meta: {
                                            title: '설정',
                                            pageTitle: '환경설정',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                    {
                                        path: 'deleteAccount',
                                        name: 'deleteAccount',
                                        component: () => import('@/ui/menu/myPage/mySetting/DeleteAccount.vue'),
                                        meta: {
                                            title: '회원탈퇴',
                                            pageTitle: '회원탈퇴',
                                            menuCate: '마이페이지',
                                            layout: defaultLayout,
                                            menuCateLink: 'myPageHome'
                                        }
                                    },
                                ]
                            },

                            {
                                path: `${this.baseContext}/systemIntro`,
                                name: 'systemIntro',
                                component: () => import('@/ui/menu/system/SystemIntro.vue'),
                                meta: {
                                    title: '시스템소개',
                                    pageTitle: '시스템소개',
                                    menuCate: '시스템소개',
                                    layout: defaultLayout,
                                    isMobilePage: true
                                }
                            },
                            {
                                path: `${this.baseContext}/serviceHospitalList`,
                                name: 'serviceHospitalList',
                                component: () => import('@/ui/menu/system/ServiceHospitalListView.vue'),
                                meta: {
                                    title: '전산청구 가능 참여병원',
                                    pageTitle: '전산청구 가능 참여병원',
                                    menuCate: '전산청구 가능 참여병원',
                                    layout: defaultLayout,
                                    isMobilePage: true
                                }
                            },

                            //------------------------로그인 및 아이디/비밀번호 찾기-----------------------
                            {
                                path: `${this.baseContext}/login`,
                                name: 'login',
                                component: () => import('@/ui/menu/member/Login.vue'),
                                meta: {title: '로그인', pageTitle: '로그인', menuCate: '로그인'},
                                children: [
                                    {
                                        path: `loginEasy/:id`,
                                        name: 'loginEasy',
                                        component: () => import('@/ui/menu/member/LoginDetail.vue'),
                                        beforeEnter: (to, from, next) => {
                                            if (/^\d+$/.test(to.params.id)) {
                                                const id = parseInt(to.params.id);
                                                if (1 === id) {
                                                    next();
                                                } else {
                                                    next({path: '/claim/web/notFound'});
                                                }
                                            } else {
                                                next({path: '/claim/web/notFound'});
                                            }
                                        }
                                    },
                                    {
                                        path: `loginMobile/:id`,
                                        name: 'loginMobile',
                                        component: () => import('@/ui/menu/member/LoginDetail.vue'),
                                        beforeEnter: (to, from, next) => {
                                            if (/^\d+$/.test(to.params.id)) {
                                                const id = parseInt(to.params.id);
                                                if (2 === id) {
                                                    next();
                                                } else {
                                                    next({path: '/claim/web/notFound'});
                                                }
                                            } else {
                                                next({path: '/claim/web/notFound'});
                                            }
                                        }
                                    },
                                    {
                                        path: `loginCertificate/:id`,
                                        name: 'loginCertificate',
                                        component: () => import('@/ui/menu/member/LoginDetail.vue'),
                                        beforeEnter: (to, from, next) => {
                                            if (/^\d+$/.test(to.params.id)) {
                                                const id = parseInt(to.params.id);
                                                if (3 === id) {
                                                    next();
                                                } else {
                                                    next({path: '/claim/web/notFound'});
                                                }
                                            } else {
                                                next({path: '/claim/web/notFound'});
                                            }
                                        }
                                    },
                                ]
                            },
                            {
                                path: `${this.baseContext}/resultFindId`,
                                name: 'resultFindId',
                                component: () => import('@/ui/menu/member/ResultFindId.vue'),
                                meta: {title: '아이디 찾기 완료', pageTitle: '아이디 찾기 완료', menuCate: '아이디 찾기'},
                            },
                            {
                                path: `${this.baseContext}/updatePwd`,
                                name: 'updatePwd',
                                component: () => import('@/ui/menu/member/UpdatePwd.vue'),
                                meta: {title: '비밀번호 변경', pageTitle: '비밀번호 변경', menuCate: '비밀번호 변경'},
                            },
                            // web 회원가입 -----------------------------------
                            {
                                path: `${this.baseContext}/termsAgree`,
                                name: 'termsAgree',
                                component: () => import('@/ui/menu/member/TermsAgree.vue'),
                                meta: {
                                    title: '약관동의',
                                    pageTitle: '약관동의',
                                    menuCate: '회원가입',
                                    currentStep: 1,
                                    layout: defaultLayout
                                },
                            },
                            {
                                path: `${this.baseContext}/joinCheck`,
                                name: 'joinCheck',
                                component: () => import('@/ui/menu/member/JoinCheck.vue'),
                                meta: {
                                    title: '회원가입 본인인증',
                                    pageTitle: '회원가입 본인인증',
                                    menuCate: '회원가입',
                                    currentStep: 2,
                                    layout: defaultLayout
                                },
                            },
                            {
                                path: `${this.baseContext}/memberDetailForm`,
                                name: 'memberDetailForm',
                                component: () => import('@/ui/menu/member/MemberDetailForm.vue'),
                                meta: {
                                    title: '회원가입 정보입력',
                                    pageTitle: '회원가입 정보입력',
                                    menuCate: '회원가입',
                                    currentStep: 3,
                                    layout: defaultLayout
                                },
                            },
                            {
                                path: `${this.baseContext}/joinRegistSNS`,
                                name: 'joinRegistSNS',
                                component: () => import('@/ui/menu/member/JoinRegistSNS.vue'),
                                meta: {
                                    title: '간편 로그인 등록',
                                    pageTitle: '간편 로그인 등록',
                                    menuCate: '회원가입',
                                    layout: defaultLayout
                                },
                            },
                            // web 회원가입 -----------------------------------
                            // SNS 로그인 관련  -------------------------------------
                            {
                                // 네이버 소셜로그인 연동 콜백
                                path: `${this.baseContext}/oauth/callback/register/naver`,
                                name: 'naverRegisterCall',
                                component: () => import('@/ui/menu/member/NaverRegisterCall.vue'),
                                meta: {title: '네이버 로그인 연동', pageTitle: '네이버 로그인 연동', menuCate: '네이버 로그인 연동'},
                            },
                            {
                                // 네이버 소셜로그인 콜백
                                path: `${this.baseContext}/oauth/callback/login/naver`,
                                name: 'naverLoginCall',
                                component: () => import('@/ui/menu/member/NaverLoginCall.vue'),
                                meta: {title: '네이버 로그인', pageTitle: '네이버 로그인', menuCate: '네이버 로그인'},
                            },
                            {
                                // 카카오 소셜로그인 연동 콜백
                                path: `${this.baseContext}/oauth/callback/register/kakao`,
                                name: 'kakaoRegisterCall',
                                component: () => import('@/ui/menu/member/KakaoRegisterCall.vue'),
                                meta: {title: '카카오 로그인 연동', pageTitle: '카카오 로그인 연동', menuCate: '카카오 로그인 연동'},
                            },
                            {
                                // 카카오 소셜로그인 콜백
                                path: `${this.baseContext}/oauth/callback/login/kakao`,
                                name: 'kakaoLoginCall',
                                component: () => import('@/ui/menu/member/KakaoLoginCall.vue'),
                                meta: {title: '카카오 로그인', pageTitle: '카카오 로그인', menuCate: '카카오 로그인'},
                            },
                            {
                                // 구글 소셜로그인 연동 콜백
                                path: `${this.baseContext}/oauth/callback/register/google`,
                                name: 'googleRegisterCall',
                                component: () => import('@/ui/menu/member/GoogleRegisterCall.vue'),
                                meta: {title: '구글 로그인 연동', pageTitle: '구글 로그인 연동', menuCate: '구글 로그인 연동'},
                            },
                            {
                                // 구글 소셜로그인 콜백
                                path: `${this.baseContext}/oauth/callback/login/google`,
                                name: 'googleLoginCall',
                                component: () => import('@/ui/menu/member/GoogleLoginCall.vue'),
                                meta: {title: '구글 로그인', pageTitle: '구글 로그인', menuCate: '구글 로그인'},
                            },
                            {
                                // 애플 소셜로그인 연동 콜백
                                path: `${this.baseContext}/oauth/callback/register/apple`,
                                name: 'appleRegisterCall',
                                component: () => import('@/ui/menu/member/AppleRegisterCall.vue'),
                                meta: {title: '애플 로그인 연동', pageTitle: '애플 로그인 연동', menuCate: '애플 로그인 연동'},
                            },
                            {
                                // 애플 소셜로그인 콜백
                                path: `${this.baseContext}/oauth/callback/login/apple`,
                                name: 'appleLoginCall',
                                component: () => import('@/ui/menu/member/AppleLoginCall.vue'),
                                meta: {title: '애플 로그인', pageTitle: '애플 로그인', menuCate: '애플 로그인'},
                            },
                            // // SNS 로그인 관련 -------------------------------------
                            // 휴대폰본인인증 관련
                            {
                                path: `${this.baseContext}/sci/pcc/return`,
                                name: 'sciPccCallBack',
                                component: () => import('@/ui/menu/member/SciCallBack.vue'),
                                meta: {title: '휴대폰인증관련', pageTitle: '휴대폰인증관련', menuCate: '휴대폰인증관련'},
                            },
                            {
                                path: `${this.baseContext}/sci/cba/return`,
                                name: 'sciCbaCallBack',
                                component: () => import('@/ui/menu/member/SciCallBack.vue'),
                                meta: {title: '아이핀인증관련', pageTitle: '아이핀인증관련', menuCate: '아이핀인증관련'},
                            },
                            {
                                path: `${this.baseContext}/sci/name/return`,
                                name: 'sciNameCallBack',
                                component: () => import('@/ui/menu/member/SciCallBack.vue'),
                                meta: {title: '실명인증관련', pageTitle: '실명인증관련', menuCate: '실명인증관련'},
                            },
                            // 고객지원 --------------------------------------
                            {
                                path: `${this.baseContext}/custSupp`,
                                name: 'custSupp',
                                redirect: `${this.baseContext}/custSupp/custSuppMain`,
                                meta: {isMobilePage: true, isAccessPath: true},
                                children: [
                                    {
                                        // 고객지원 메인
                                        path: 'custSuppMain',
                                        name: 'custSuppMain',
                                        component: () => import('@/ui/menu/custSupp/CustSuppMain.vue'),
                                        meta: {
                                            title: '고객지원',
                                            pageTitle: '고객지원',
                                            menuCate: '고객지원',
                                            layout: subHomeLayout,
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // 문의하기
                                        path: 'custSuppQNA',
                                        name: 'custSuppQNA',
                                        component: () => import('@/ui/menu/custSupp/CustSuppQNA.vue'),
                                        meta: {
                                            title: '문의하기',
                                            pageTitle: '문의하기',
                                            menuCate: '고객지원',
                                            authRequired: true,
                                            menuCateLink: 'custSuppMain',
                                            layout: defaultLayout
                                        },
                                    },
                                    {
                                        // 문의내역 수정하기
                                        path: 'custSuppQNAFetch',
                                        name: 'custSuppQNAFetch',
                                        component: () => import('@/ui/menu/custSupp/CustSuppQNAFetch.vue'),
                                        meta: {
                                            title: '문의내역',
                                            pageTitle: '문의내역',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            isMobilePage: true,
                                        },
                                    },
                                    {
                                        // 문의내역 상세보기
                                        path: 'custSuppQNADetail',
                                        name: 'custSuppQNADetail',
                                        component: () => import('@/ui/menu/custSupp/CustSuppQNADetail.vue'),
                                        meta: {
                                            title: '문의내역',
                                            pageTitle: '문의내역',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true,
                                        },
                                    },
                                    {
                                        // 공지사항
                                        path: 'custSuppNotice',
                                        name: 'custSuppNotice',
                                        component: () => import('@/ui/menu/custSupp/CustSuppNotice.vue'),
                                        meta: {
                                            title: '공지사항',
                                            pageTitle: '공지사항',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // 공지사항 상세보기
                                        path: 'custSuppNoticeDetail',
                                        name: 'custSuppNoticeDetail',
                                        component: () => import('@/ui/menu/custSupp/CustSuppNoticeDetail.vue'),
                                        meta: {
                                            title: '공지사항',
                                            pageTitle: '공지사항',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // FAQ
                                        path: 'custSuppFAQ',
                                        name: 'custSuppFAQ',
                                        component: () => import('@/ui/menu/custSupp/CustSuppFAQ.vue'),
                                        meta: {
                                            title: '자주하는 질문',
                                            pageTitle: '자주하는 질문',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // 자료실
                                        path: 'custSuppLib',
                                        name: 'custSuppLib',
                                        component: () => import('@/ui/menu/custSupp/CustSuppLib.vue'),
                                        meta: {
                                            title: '자료실',
                                            pageTitle: '자료실',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // 자료실 상세보기
                                        path: 'custSuppLibDetail',
                                        name: 'custSuppLibDetail',
                                        component: () => import('@/ui/menu/custSupp/CustSuppLibDetail.vue'),
                                        meta: {
                                            title: '자료실',
                                            pageTitle: '자료실',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // 고객지원
                                        path: 'custSuppService',
                                        name: 'custSuppService',
                                        component: () => import('@/ui/menu/custSupp/CustSuppService.vue'),
                                        meta: {
                                            title: '고객상담',
                                            pageTitle: '고객상담',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                    {
                                        // AI챗봇상담
                                        path: 'custSuppAI',
                                        name: 'custSuppAI',
                                        component: () => {
                                            const openAiChat = () => {
                                                var width = window.innerWidth * 0.4;
                                                var height = window.innerHeight * 0.7;
                                                var left = (window.innerWidth - width) / 2;
                                                var top = (window.innerHeight - height) / 2;
                                                // window.open('https://chb.tsilson24.or.kr:9300/chat', '_blank', `width=${width},height=${height}`);
                                                window.open(process.env.VUE_APP_CHATBOT_URL, '_blank', `width=${width},height=${height}`);
                                            }

                                            openAiChat();
                                        },
                                        meta: {
                                            title: 'AI챗봇상담',
                                            pageTitle: 'AI챗봇상담',
                                            menuCate: '고객지원',
                                            layout: defaultLayout,
                                            menuCateLink: 'custSuppMain',
                                            isMobilePage: true
                                        },
                                    },
                                ]
                            },
                            {
                                path: `${this.baseContext}/appDownload`,
                                name: 'appDownload',
                                component: () => import('@/ui/QrDownload.vue'),
                                meta: {
                                    title: 'qr 앱 다운로드',
                                    pageTitle: 'qr 앱 다운로드',
                                    menuCate: 'qr 앱 다운로드',
                                    isMobilePage: false,
                                    layout: noGnbLayout
                                },
                            },
                            // // 고객지원 -----------------------------------
                            //없는 페이지 ------------------------------------
                            {
                                path: '/:pathMatch(.*)*',
                                name: 'NotFound',
                                component: () => import('@/ui/NotFound.vue'),
                                meta: {
                                    title: '404에러화면',
                                    pageTitle: '에러화면',
                                    menuCate: '공통',
                                    layout: noGnbLayout,
                                    isMobilePage: true
                                }
                            },
                        ]
                    )
                }, 6.7);
            });
        }
    }
}

const router = new GenericRouter();
await router.dynamic();

export {router as default}